<!-- 表3填写 -->

<template>
  <div class="tabCage table9E">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 2-1：音像制品出版情况登记表</span>
      <span v-else>表 2-1：电子出版物出版情况登记表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">年份：</td>
            <td class="edInp edSelect">
              <el-form-item prop="year" :inline-message="true">
                <el-select :disabled="onlyEditMode" v-model="params.year" size="small" placeholder="请选择">
                  <el-option v-for="item in yearOpts" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-checkbox v-model="checked">本年度无出版物</el-checkbox> -->
            </td>
          </tr>
          <template v-if="!checked">
            <tr>
              <td class="edName">出版物名称：</td>
              <td class="edInpBig">
                <el-form-item prop="publicationName" :inline-message="true">
                  <el-input
                    :disabled="onlyEditMode"
                    v-model="params.publicationName"
                    size="small"
                    placeholder="请输入出版物名称"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="edName">专用书号（ISBN 978-7-）：</td>
              <td class="edInp">
                <el-form-item disabled="true" prop="isbn" :inline-message="true">
                  <el-input
                    :disabled="onlyEditMode"
                    v-model="params.isbn"
                    size="small"
                    placeholder="请输入专用书号"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="edName">载体形式：</td>
              <td class="edInp">
                <div class="areaTime" v-if="pressType == 1">
                  <el-form-item prop="carrierForm" :inline-message="true">
                    <el-select
                      :disabled="onlyEditMode"
                      v-model="params.carrierForm"
                      size="small"
                      placeholder="请选择载体形式"
                      @change="numHandle">
                      <el-option v-for="item in dicDats['C010']" :key="item.code" :label="item.name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="carrierFormQT"
                    :inline-message="true"
                    v-if="mediaTyp1[params.carrierForm] == '其他'">
                    <el-input size="small" v-model="params.carrierFormQT"></el-input>
                  </el-form-item>
                </div>
                <div class="areaTime" v-else-if="pressType == 2">
                  <el-form-item prop="carrierForm" :inline-message="true">
                    <el-select
                      v-model="params.carrierForm"
                      size="small"
                      placeholder="请选择载体形式"
                      @change="numHandle">
                      <el-option v-for="item in dicDats['C025']" :key="item.code" :label="item.name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    prop="carrierFormQT"
                    :inline-message="true"
                    v-if="mediaTyp2[params.carrierForm] == '其他'">
                    <el-input v-model="params.carrierFormQT" size="small"></el-input>
                  </el-form-item>
                </div>
              </td>
            </tr>
            <tr>
              <td class="edName">出版形式：</td>
              <td class="edInp">
                <el-form-item prop="publicationForm" :inline-message="true">
                  <el-select v-model="params.publicationForm" size="small" placeholder="请选择出版形式">
                    <el-option v-for="item in dicDats['C011']" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item prop="publicationForm" :inline-message="true" v-if="isSub[params.mediaForm] == '其他'">
																																								   <el-input size="small" placeholder="请输入节目来源/制作单位"></el-input>
																																							 </el-form-item> -->
              </td>
            </tr>
            <tr>
              <td class="edName">节目来源/制作单位：</td>
              <td class="edInpBig">
                <el-form-item prop="productionUnit" :inline-message="true">
                  <el-input
                    v-model="params.productionUnit"
                    size="small"
                    placeholder="请输入节目来源/制作单位"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="edName">节目时长或容量(分钟/兆)：</td>
              <td class="edInp">
                <el-form-item prop="programCapacity" :inline-message="true">
                  <el-input-number
                    v-model="params.programCapacity"
                    controls-position="right"
                    :controls="false"
                    :min="0"
                    size="small"></el-input-number>
                </el-form-item>
              </td>
            </tr>
            <tr v-if="numShow">
              <td class="edName">出版数量(张/盒)：</td>
              <td class="edInp">
                <el-form-item prop="publicationQuantity" :inline-message="true">
                  <el-input-number
                    v-model="params.publicationQuantity"
                    controls-position="right"
                    :controls="false"
                    :min="0"
                    size="small"></el-input-number>
                </el-form-item>
              </td>
            </tr>
            <!-- <tr v-if="numShow">
              <td class="edName">发行数量(张/盒)：</td>
              <td class="edInp">
                <el-form-item prop="issueQuantity" :inline-message="true">
                  <el-input-number
                    v-model="params.issueQuantity"
                    controls-position="right"
                    :controls="false"
                    :min="0"
                    size="small"></el-input-number>
                </el-form-item>
              </td>
            </tr> -->
            <!-- <tr v-if="numShow">
              <td class="edName">发行单价(元)：</td>
              <td class="edInp">
                <el-form-item prop="unitPrice" :inline-message="true">
                  <el-input-number
                    v-model="params.unitPrice"
                    controls-position="right"
                    :controls="false"
                    :min="0"
                    size="small"></el-input-number>
                </el-form-item>
              </td>
            </tr> -->
            <tr v-if="publishingTimeShow">
              <td class="edName">出版时间：</td>
              <td class="edInp">
                <el-form-item prop="publishingTime" :inline-message="true">
                  <el-date-picker
                    @blur="timeTrans(timeStore.time1, 'publishingTime')"
                    v-model="timeStore.time1"
                    type="date"
                    size="small"
                    value-formate="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </td>
            </tr>
            <!-- <tr>
              <td class="edName">是否缴送样本：</td>
              <td class="edInp areaTime">
                <el-form-item prop="sampleDelivery" :inline-message="true">
                  <el-select v-model="params.sampleDelivery" size="small" placeholder="请选择是否缴送样本">
                    <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <span class="tips">按规定向国家版本馆、国家图书馆缴送样本</span>
              </td>
            </tr> -->
            <tr>
              <td class="edName">是否书配盘标记：</td>
              <td class="edInp areaTime">
                <el-form-item prop="sign" :inline-message="true">
                  <el-select v-model="params.sign" size="small" placeholder="请选择是否书配盘标记">
                    <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <span class="tips">是否为配合本版出版物的音像制品</span>
              </td>
            </tr>
          </template>
        </table>
      </el-form>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt9";
import { tabUpdate9, tabRead9 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: bsParams,
      pressType: this.$route.query.pressType,
      rules: paramsRule,
      submiting: false,
      dicDats: {},
      mediaTyp1: {},
      mediaTyp2: {},
      numShow: true,
      // 是否显示出版时间
      publishingTimeShow: true,
      yearOpts: [
        { code: 2021, name: "2021年" },
        { code: 2022, name: "2022年" },
      ],

      timeStore: {
        time1: "",
      },

      //编辑模式下可以变更的项目有限
      onlyEditMode: true,
      checked: false,
      emptyDate: {
        year: "", // 年度
        publicationName: "无", // 出版物名称
        isbn: "无", // 专用书号 ISBN
        carrierForm: "", // 载体形式（选择项）
        carrierFormQT: "未出版", // 载体形式其他
        publicationForm: "", // 出版形式（选择项）
        productionUnit: "无", // 节目来源/制作单位
        programCapacity: 0, // 节目时长或容量(分钟/兆)
        publicationQuantity: 0, // 出版数量（张/盒）
        issueQuantity: 0, // 发行数量（张/盒）
        unitPrice: 0, // 发行单价（元）
        publishingTime: "2019-04-22", // 出版时间
        sampleDelivery: "", // 样品缴送（选择项）
        sign: "", // 书配盘标记（选择项）

        publishMaterialId: "", // publishMaterialId
        publishId: "", // 出版单位ID
      },
      pubStatus: 0,
    };
  },
  methods: {
    dictInit: function () {
      let nameArr = ["C010", "C011", "C018", "C025", "C012"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      let vm = this;
      newPromise.then((result) => {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.mediaTyp1 = vm.$store.getters.dictionary["C010"];
        vm.mediaTyp2 = vm.$store.getters.dictionary["C025"];

        for (let key in vm.isNot) {
          if (vm.isNot[key] == "否") {
            vm.params.sampleDelivery = key;
            this.emptyDate.sampleDelivery = key;
            this.emptyDate.sign = key;
          }
        }

        if (this.pressType == 1) {
          for (let key in vm.mediaTyp1) {
            if (vm.mediaTyp1[key] == "其他") {
              this.emptyDate.carrierForm = key;
            }
          }
        } else if (this.pressType == 2) {
          for (let key in vm.mediaTyp2) {
            if (vm.mediaTyp2[key] == "其他") {
              this.emptyDate.carrierForm = key;
            }
          }
        }
      });
    },

    numHandle: function () {
      // 音像
      if (this.pressType == 1) {
        if (this.mediaTyp1[this.params.carrierForm] == "电子-信息网络出版") {
          this.numShow = false;
        } else if (this.mediaTyp1[this.params.carrierForm] == "电子出版-电子书") {
          this.rules.publishingTime[0].required = false;
          // this.publishingTimeShow = false;
        } else {
          this.rules.publishingTime[0].required = true;
          // this.publishingTimeShow = true;
          this.numShow = true;
        }
      }
      // 电子
      else if (this.pressType == 2) {
        if (this.mediaTyp2[this.params.carrierForm] == "电子-信息网络出版") {
          this.numShow = false;
        } else if (this.mediaTyp2[this.params.carrierForm] == "电子出版-电子书") {
          this.rules.publishingTime[0].required = false;
          // this.publishingTimeShow = false;
        } else {
          this.rules.publishingTime[0].required = true;
          // this.publishingTimeShow = true;
          this.numShow = true;
        }
      }

      if (this.numShow == false) {
        this.params.publicationQuantity = 0;
        this.params.issueQuantity = 0;
        this.params.unitPrice = 0;
      }
    },

    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;
          this.params.type = this.$route.query.pressType;

          this.emptyDate.publishId = this.$route.query.pressId;
          this.emptyDate.publishMaterialId = this.$route.query.mtId;

          var postDat = {
            //后台身份验证用.hsj
            publishMaterialId: this.$route.query.mtId,
          };
          if (this.checked) {
            this.emptyDate.year = this.params.year;
            //    postDat.ppublication = this.emptyDate;
            postDat.data = this.emptyDate;
          } else {
            //    postDat.ppublication = this.params;
            postDat.data = this.params;
          }

          //参数写在外边了
          tabUpdate9(postDat)
            .then((response) => {
              let tipCode = response.payload.ppublication.code;
              let tipMessage = response.payload.ppublication.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error(`保存错误: ${tipMessage}`);
                return;
              }
              this.$message({
                message: "保存成功！",
                type: "success",
              });

              this.goBack();
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    btnCtrls: function (type, dats) {
      if (type == 1) {
        this.btnCtrls1 = false;
      } else if (type == 2) {
        this.btnCtrls2 = false;
      }
    },

    mtReEdit: function () {
      tabRead9({ id: this.$route.query.id }).then((response) => {
        this.params = response.ppublication;
        this.timeStore.time1 = this.params.publishingTime;
        // 只有电子里面有这个选项
        if (this.mediaTyp2[this.params.carrierForm] == "电子出版-电子书") {
          this.rules.publishingTime[0].required = false;
          // this.publishingTimeShow = false;
        } else {
          this.rules.publishingTime[0].required = true;
          // this.publishingTimeShow = true;
        }
      });
    },

    goBack: function () {
      var page = sessionStorage.getItem("fromPage");
      sessionStorage.setItem("toPage", page);
      this.$router.go(-1);
    },

    timeTrans: function (dat, strName) {
      var dayv = new Date(dat);
      var y = dayv.getFullYear();
      var m = dayv.getMonth() + 1;
      var d = dayv.getDate();

      if (m < 10) {
        m = "0" + m;
      }

      if (d < 10) {
        d = "0" + d;
      }

      this.params[strName] = y + "-" + m + "-" + d;
    },
  },
  created: function () {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.mtReEdit();
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table9E .edInp .el-input-number {
  width: 300px;
}

.table9E {
  .areaTime .el-form-item {
    display: inline-block;
    vertical-align: middle;
  }

  .areaTime .tips {
    margin-left: 12px;
  }
}

.table9E .edName {
  width: 240px !important;
}

.table9E {
  .edSelect {
    .el-form-item {
      display: inline-block;
    }

    .el-checkbox {
      margin-left: 30px;

      .el-checkbox__label {
        // font-size: 12px;
        color: #666666;
        padding-left: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table9.vue?e8defbb8